"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickAway = void 0;
var react_1 = require("react");
var useEventListener_1 = require("./useEventListener");
var MOUSE_DOWN = "mousedown";
var TOUCH_START = "touchstart";
function useClickAway(ref, handler, controllerRef) {
    var listener = (0, react_1.useCallback)(function (event) {
        if (isContained(ref, event.target) &&
            isContained(controllerRef, event.target)) {
            handler === null || handler === void 0 ? void 0 : handler(event);
        }
    }, [handler, ref, controllerRef]);
    (0, useEventListener_1.useEventListener)({
        type: MOUSE_DOWN,
        listener: listener,
    });
    (0, useEventListener_1.useEventListener)({
        type: TOUCH_START,
        listener: listener,
    });
}
exports.useClickAway = useClickAway;
var isContained = function (ref, target) { var _a; return ref && ref.current && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)); };
